module.exports = __webpack_public_path__ + "static/family_engagement_desktop-aef8b0d7c4baa8d0bf63a77a8d71cfe9.png";